import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Table from "../../components/Table";
import Layout from "../../components/Layout";

import SubscriptionStatusBadge from "../../components/Subscription/SubscriptionStatusBadge";
import SubscriptionBulkActions from "../../components/Subscription/SubscriptionBulkActions";
import { SubscriptionNavigationTabs } from "../../components/NavigationTabs/SubscriptionNavigationTabs";

export default function ManageSubscriptionsPage() {
  const router = useRouter();
  const { created } = router.query;

  const [subscriptionCreated, setSubscriptionCreated] = useState(false);

  useEffect(() => {
    setSubscriptionCreated(created === "true");
  }, [created]);
  return (
    <Layout metaTitle="Manage Subscriptions">
      <Table
        url="/d/subscriptions/"
        tableName="subscription"
        tableTitle="Manage all your subscriptions"
        tableDescription="Manage your customer's subscriptions, check the status of each, take needed actions, create new subscriptions and get paid regularly."
        getPreviewPath={(row) => `/subscriptions/${row.id}`}
        enableRowClickNavigation
        BulkActionsComponent={SubscriptionBulkActions}
        customRender={{
          status: SubscriptionStatusBadge,
        }}
        onAddItemClick={() => {
          router.push({
            pathname: "/subscriptions/add",
          });
        }}
        itemAddedSuccessfullyMessage={
          subscriptionCreated
            ? "Subscription has been created successfully!"
            : ""
        }
        navigationTabs={
          <SubscriptionNavigationTabs activeTab="subscriptions" />
        }
      />
    </Layout>
  );
}

ManageSubscriptionsPage.parentPath = "/subscriptions";
